import { Outlet } from "react-router";

const UtilityLayout = () => {
  return (
      <>
          <Outlet />
      </>
  );
};

export default UtilityLayout;